var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractMdg2Request } from './AbstractMdg2Request';
var HighLevelRequest = (function (_super) {
    __extends(HighLevelRequest, _super);
    function HighLevelRequest(method, path, data, options) {
        if (data === void 0) { data = {}; }
        var _this = _super.call(this, HighLevelRequest.NAME, HighLevelRequest.VERSION) || this;
        _this.members.accept = 'application/json';
        _this.members.content_type = 'application/json';
        _this.members.body = { value: [] };
        _this.members.query = '';
        _this.members.path = path;
        _this.setMethod(method);
        if (data && method === 'POST') {
            _this.setBody(data);
        }
        else {
            _this.setQuery(data);
        }
        if (options) {
            _this.setOptions(options);
        }
        return _this;
    }
    HighLevelRequest.prototype.setOptions = function (options) {
        if (options.hasOwnProperty('accept')) {
            this.members.accept = options.accept;
        }
        if (options.hasOwnProperty('content_type')) {
            this.members.content_type = options.content_type;
        }
        if (options.hasOwnProperty('subscribe') && options.subscribe) {
            this.header.setFlag('add_subscription');
        }
        if (options.hasOwnProperty('no_merge') && options.no_merge) {
            this.header.setFlag('no_merge');
        }
        if (options.hasOwnProperty('idApplication') && options.idApplication) {
            this.header.setIdApplication(options.idApplication);
        }
        if (options.hasOwnProperty('idUser') && options.idUser) {
            this.header.setIdUser(options.idUser);
        }
    };
    HighLevelRequest.prototype.setMethod = function (method) {
        var ptlMethod = method === 'POST' ? HighLevelRequest.METHOD.POST : HighLevelRequest.METHOD.GET;
        this.members.method = { value: ptlMethod };
    };
    HighLevelRequest.prototype.setBody = function (data) {
        if (data === void 0) { data = {}; }
        if (data instanceof Array) {
            this.members.body = { value: data };
        }
        else {
            this.members.body = { value: JSON.stringify(data) };
        }
    };
    HighLevelRequest.prototype.getData = function () {
        if (this.members.method.value === HighLevelRequest.METHOD.POST) {
            return HighLevelRequest.ptlToJsonData(this.members.body.value);
        }
        return this.members.query;
    };
    HighLevelRequest.prototype.setQuery = function (data) {
        if (data === void 0) { data = {}; }
        this.members.query = Object.keys(data)
            .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]); })
            .join('&');
    };
    HighLevelRequest.ptlToJsonData = function (data) {
        if (typeof (data) === 'string') {
            return JSON.parse(data);
        }
        if (data instanceof Array && data.length > 0) {
            var dataString_1 = '';
            data.forEach(function (item) {
                dataString_1 += String.fromCharCode(item);
            });
            return JSON.parse(dataString_1);
        }
    };
    HighLevelRequest.NAME = 'HighLevelRequest';
    HighLevelRequest.VERSION = 2;
    HighLevelRequest.METHOD = {
        GET: 1,
        POST: 2
    };
    return HighLevelRequest;
}(AbstractMdg2Request));
export { HighLevelRequest };
//# sourceMappingURL=HighLevelRequest.js.map